import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse, RephraseParams } from '@/types'

export const coverletterWidget = async (options: any): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  const data = Object.assign({}, options)
  try {
    const response = await http.post(`generators/cover-letter-widget`, {
      ...data,
    })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
export const coverletter = async (options: any): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  const data = Object.assign({}, options)
  try {
    const response = await http.post(
      `generators/cover-letter`,
      { ...data },
      {
        timeout: 30000, // 30 seconds
      }
    )

    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const skillPhrases = async (options: any): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  const data = Object.assign({}, options)
  try {
    const response = await http.post(`generators/skill-phrases`, { ...data })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const rephrase = async (
  options: RephraseParams
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  const data = Object.assign({}, options)
  try {
    const response = await http.post(`generators/rephrase`, { ...data })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const resumeSummary = async (resumeId): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`generators/resume-summary`, { resumeId })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const linkedinHeadline = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`generators/linkedin-headline`)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const linkedinSummary = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`generators/linkedin-summary`)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

interface NetworkMessageParams {
  connection: string
  fact: string
  interaction: string
  limit: number
  job: string
  goal: string
  company: string
  ask: string
  skills: string[]
}

export const networkMessage = async (
  params: NetworkMessageParams
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  const skillsString = params.skills.join(', ')
  try {
    const response = await http.post(`generators/linkedin-network-message`, {
      ...params,
      skills: skillsString,
    })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
